import styled from 'styled-components';

export const CardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  justify-content: center;
  padding: 10px;
`;

export const Card = styled.div`
  flex: 0 0 calc(33.333% - 40px);
  min-width: 450px;
  max-width: calc(33.333% - 40px);
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin: 10px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 200px;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 1400px) {
    flex: 0 0 calc(50% - 40px);
    max-width: calc(50% - 40px);
  }

  @media (max-width: 900px) {
    flex: 0 0 calc(100% - 40px);
    max-width: calc(100% - 40px);
  }
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

export const CardTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #333;

`;

export const CardText = styled.p`
  font-size: 13px;
  color: #333;
  margin-bottom: 0px;
  font-weight: 600;


`;

export const CardStatsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 10px;
`;

export const CardStat = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export const ColoredCardCircle = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: ${props => props.color || '#000'};
`;

export const CardStatText = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: #333;
`;


export const StatItem = styled.div`
  display: flex;
  color: #555;
  font-size: 14px;
`;

export const StatLabel = styled.span`
  font-weight: 500;
  margin-right: 5px;
  text-transform: capitalize;
  font-size: 14px;
`;

export const StatValue = styled.span`
  font-weight: 600;
`;




export const CardLeftContent = styled.div`
  flex: 0 0 55%;
  padding-right: 15px;
`;

export const CardRightContent = styled.div`
  flex: 0 0 45%;
  display: flex;
  justify-content: flex-end;
`;

// Circular Progress Chart Components
export const CircularProgressContainer = styled.div`
  position: relative;
  width: 200px;
  height: 200px;
  cursor: pointer;
`;

export const CircularProgressSVG = styled.svg`
  transform: rotate(180deg);
  width: 100%;
  height: 100%;
`;

export const CircularProgressBackground = styled.circle`
  fill: transparent;
  stroke: #E5E7EB;
  stroke-width: ${props => props.strokeWidth || 15};
`;

export const CircularProgressFill = styled.circle`
  fill: transparent;
  stroke: ${props => props.color || '#4d94fb'};
  stroke-width: ${props => props.strokeWidth || 15};
  stroke-dasharray: ${props => props.circumference};
  stroke-dashoffset: ${props => props.circumference - (props.percentage / 100) * props.circumference};
  transition: stroke-dashoffset 0.5s ease;
`;

export const CircularProgressInner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CircularProgressText = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #333;
`;

// Inner progress circles
export const InnerProgressContainer = styled.div`
  position: absolute;
  width: 60px;
  height: 60px;

  &:nth-child(1) {
    top: 30px;
    left: 70px;
  }

  &:nth-child(2) {
    bottom: 30px;
    left: 40px;
  }

  &:nth-child(3) {
    bottom: 30px;
    right: 40px;
  }
`;

export const InnerProgressSVG = styled.svg`
  transform: rotate(180deg);
  width: 100%;
  height: 100%;
`;

export const InnerProgressBackground = styled.circle`
  fill: white;
  stroke: #f0f0f0;
  stroke-width: 6;
`;

export const InnerProgressFill = styled.circle`
  fill: transparent;
  stroke: ${props => props.color || '#4d94fb'};
  stroke-width: 6;
  stroke-dasharray: ${props => props.circumference};
  stroke-dashoffset: ${props => props.circumference - (props.percentage / 100) * props.circumference};
  transition: stroke-dashoffset 0.5s ease;
`;

export const InnerProgressText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
  font-weight: 700;
  color: #333;
`;

// Small inner circles
export const InnerCirclesContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InnerCircle = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: ${props => props.color || '#ccc'};
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

  &:nth-child(1) {
    transform: translate(-40px, -20px); /* Top left */
  }

  &:nth-child(2) {
    transform: translate(0px, 40px); /* Bottom */
  }

  &:nth-child(3) {
    transform: translate(40px, -20px); /* Top right */
  }
`;

export const InnerCircleText = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: white;
`;

// Add the missing exports that StatisticsContainer.jsx is looking for
export const EvaluationCardsContainer = CardsContainer;
export const EvaluationCard = Card;
export const EvaluationCardTitle = CardTitle;
export const EvaluationCardValue = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: #4d94fb;
  margin: 15px 0;
  text-align: center;
`;

export const Tooltip = styled.div`
  position: absolute;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 12px;
  pointer-events: none;
  z-index: 1000;
  white-space: nowrap;
  transform: translate(-50%, -100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 100px;
  text-align: center;

  &:after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid rgba(0, 0, 0, 0.8);
  }
`;

export const TooltipLabel = styled.div`
  font-weight: 600;
`;

export const TooltipValue = styled.div`
  font-size: 14px;
  font-weight: 700;
`;
